<template>
    <v-card :class="{'px-3 py-4': $vuetify.breakpoint.smAndDown, 'px-5 py-5': $vuetify.breakpoint.mdAndUp}" :style="$vuetify.breakpoint.lgAndUp ? 'width:1150px' : ''">
        <v-form @submit.prevent="submit()">
            <v-icon class="modal-close" @click.native="CLOSE_MODAL('company_info')">close</v-icon>
            <v-card-title :class="{'mb-3 headline': $vuetify.breakpoint.smAndDown, 'mb-5 display-1': $vuetify.breakpoint.mdAndUp}">{{ $t("Редактировать организацию") }}</v-card-title>
            <v-layout v-if="status_access" row wrap>
                <v-radio-group v-model="statuses" class="radio-row">
                    <v-radio
                        v-for="(status, i) in company_statuses"
                        :id="'radio'+i"
                        :key="i"
                        :value="'radio'+i"
                        :name="'radio'"
                        class="flex sm6 md3 mr-0 pr-3"
                        @change="CHANGE_USER_STATUS(status)"
                    >
                        <labelTopic slot="label" :class="status.bg_color">{{ $t(status.text) }} </labelTopic>
                    </v-radio>
                </v-radio-group>
            </v-layout>
            <v-layout row wrap>
                <v-flex v-if="show_foreign_subsidiary" md4 sm6
                        xs12
                        mt-4 :class="{'pr-0': $vuetify.breakpoint.xs, 'pr-4': $vuetify.breakpoint.smAndUp}"
                >
                    <div class="grey-text mb-2">{{ $t('ЗДО') }} *</div>
                    <v-autocomplete
                        v-model="foreign_subsidiary"
                        :items="foreign_subsidiaries"
                        solo
                        attach="js-country"
                        append-icon=""
                        :label="$t('Введите ЗДО')"
                        class="input js-country"
                        item-value="id"
                        :class="{ 'form-group--error': $v.foreign_subsidiary.$error }"
                        @change="click_foreign_subsidiary($event)"
                    >
                      <template #append>
                        <v-icon aria-hidden="true" translate="no">
                          expand_more
                        </v-icon>
                      </template>
                    </v-autocomplete>
                </v-flex>
                <v-flex md4 sm6 xs12
                        mt-4
                        :class="{'pr-0': $vuetify.breakpoint.xs, 'pr-4': $vuetify.breakpoint.smAndUp}"
                >
                    <div class="grey-text mb-2">{{ $t("Название") }} *</div>

                    <inputBase :placeholder="company_page.name" :value="company_name"
                               :class="{ 'form-group--error': $v.company_name.$error }"
                               @input="input_company_name($event)"
                    />

                </v-flex>
                <v-flex md4 sm6 xs12
                        mt-4 :class="{'pr-4': $vuetify.breakpoint.mdAndUp}"
                >
                    <div class="grey-text mb-2">{{ $t('Страна') }} *</div>
                    <v-autocomplete
                        :items="countries"
                        :value="country"
                        solo
                        attach="js-country"
                        append-icon=""
                        :label="$t('Введите страну')"
                        class="input js-country"
                        item-value="id"
                        :class="{ 'form-group--error': $v.country.$error }"
                        @change="click_country($event)"
                    >
                      <template #append>
                        <v-icon aria-hidden="true" translate="no">
                          expand_more
                        </v-icon>
                      </template>
                    </v-autocomplete>
                </v-flex>
                <v-flex md4 sm6 xs12
                        mt-4
                        :class="{'pr-0': $vuetify.breakpoint.smAndDown, 'pr-4': $vuetify.breakpoint.mdAndUp}"
                >
                    <div class="grey-text mb-2">{{ $t("Регион") }} *</div>
                    <v-select
                        :disabled="country_iso !== 'RU'"
                        :items="regions"
                        :value="region"
                        solo
                        attach="js-city"
                        append-icon=""
                        :label="$t('Введите регион')"
                        class="input js-city"
                        :class="{ 'form-group--error': $v.city.$error }"
                        @change="click_region($event)"
                    >
                      <template #append>
                        <v-icon aria-hidden="true" translate="no">
                          expand_more
                        </v-icon>
                      </template>
                    </v-select>
                </v-flex>
                <v-flex md4 sm6 xs12
                        mt-4
                        :class="{'pr-4': $vuetify.breakpoint.mdAndUp}"
                >
                    <div class="grey-text mb-2">{{ $t("Город") }} *</div>

                    <v-select
                        :disabled="country_iso !== 'RU'"
                        :items="cities_filtered || ['-']"
                        :value="city"
                        solo
                        attach="js-city"
                        append-icon=""
                        :label="$t('Введите город')"
                        class="input js-city"
                        :class="{ 'form-group--error': $v.city.$error }"
                        @change="click_city($event)"
                    >
                      <template #append>
                        <v-icon aria-hidden="true" translate="no">
                          expand_more
                        </v-icon>
                      </template>
                    </v-select>

                </v-flex>
                <v-flex md4 sm6 xs12
                        mt-4 :class="{'pr-4': $vuetify.breakpoint.mdAndUp}"
                >
                    <div class="grey-text mb-2">{{ $t("Адрес") }} *</div>
                    <inputBase :placeholder="$t('Введите адресс')" :value='address'
                               :class="{ 'form-group--error': $v.address.$error }"
                               @input="input_address($event)"
                    />
                </v-flex>
                <v-flex
                    md4 sm6
                    xs12
                    mt-4
                    :class="{'pr-0': $vuetify.breakpoint.smAndDown, 'pr-4': $vuetify.breakpoint.mdAndUp}"
                >
                    <div class="grey-text mb-2">{{ $t("Тип организации") }}</div>
                    <SelectObj :company_type="company_page.types" @click="click_type($event)" />
                </v-flex>
                <!--<v-flex md4 sm6 xs12-->
                <!--mt-4-->
                <!--mb-4 :class="{'pr-4': $vuetify.breakpoint.smAndUp}" class="wrapper-relative"-->
                <!--&gt;-->
                <!--<div class="grey-text mb-2">{{$t("Логотип")}}</div>-->
                <!--<inputUpload id="logo_upload" size="64000" :placeholder="$t('Загрузить логотип...')"-->
                <!--:class="{ 'form-group&#45;&#45;error': $v.file_size.$error }"-->
                <!--@input.native="send_file($event)"-->
                <!--@setFile="set_file_size"-->
                <!--/>-->
                <!--<div class="grey-text" style="position: absolute;">{{$t("Файлы в формате jpg., png. не более 64 КБ")}} </div>-->
                <!--</v-flex>-->
                <v-flex md4 sm6 xs12
                        mt-4
                        :class="{'pr-0': $vuetify.breakpoint.smAndDown, 'pr-4': $vuetify.breakpoint.mdAndUp}"
                >
                    <div class="grey-text mb-2">{{ $t("Номер телефона") }}</div>
                    <inputBase v-mask="phoneMask"
                               :placeholder="$t('Введите номер телефона')"
                               :value="phone"
                               @input="phone = $event.target.value"
                    />
                </v-flex>
                <v-flex md4 sm6 xs12
                        mt-4
                        :class="{'pr-0': $vuetify.breakpoint.xs, 'pr-4': $vuetify.breakpoint.mdAndUp}"
                >
                    <div class="grey-text mb-2">E-mail *</div>
                    <inputBase :placeholder="$t('Введите email')" :value="email"
                               :class="{ 'form-group--error': $v.email.$error }"
                               @input="input_email($event)"
                    />
                </v-flex>
            </v-layout>

            <v-layout />
            <v-layout row mt-5>
                <v-flex>
                    <div class="grey-text mb-2">{{ $t("Деятельность организации") }}</div>
                    <textareaBase :value="about" rows="4" @input="about = $event.target.value" />
                </v-flex>
            </v-layout>
            <v-card-actions class="mt-5">
                <v-layout wrap align-center>
                    <buttonRed :class="{'flex xs12': $vuetify.breakpoint.xs}">{{ $t("Добавить") }}</buttonRed>
                    <div class="grey-text"
                         :class="{'ml-0 flex xs12 mt-2': $vuetify.breakpoint.xs, 'ml-4': $vuetify.breakpoint.smAndUp}"
                    >
                        {{ $t("* - поля, обязательные для заполнения") }}</div>
                </v-layout>
            </v-card-actions>
        </v-form>
    </v-card>
</template>

<script>
import {validationMixin} from 'vuelidate';
import {required, helpers, email, between} from 'vuelidate/lib/validators';
import buttonRed from '@/components/ui/buttons/button_red';
import inputBase from '@/components/ui/inputs/base/input';
import checkbox from '@/components/ui/inputs/base/checkbox';
import labelTopic from '@/components/ui/labels/label_topic';
import textareaBase from '@/components/ui/inputs/base/textarea';
import inputUpload from '@/components/ui/inputs/typed/input_upload.vue';
import inputIcon from '@/components/ui/inputs/typed/input_icon.vue';

import {mapGetters, mapMutations, mapActions} from 'vuex';
import SelectObj from './Company_select_obj';
import {VueMaskDirective} from 'v-mask';
import api from '../../../../api/index.js';

const optionalRegionCity = (param) =>
  (value) => param !== 'RU' || helpers.req(value);

const optionalForeignSubsidiary = (param) => (value) => {
  return !param || helpers.req(value);
};

export default {
  directives: {
    'mask': VueMaskDirective,
  },
  components: {
    buttonRed,
    inputBase,
    labelTopic,
    textareaBase,
    checkbox,
    inputUpload,
    SelectObj,
    inputIcon,
  },
  mixins: [validationMixin],
  props : {
    status_access: {
      type: Boolean,
    },
    company_page: {
      type: Object,
    },
  },
  validations() {
    return {
      file_size: {
        between: between(0, 64000),
      },
      company_name: {
        required,
      },
      country: {
        required,
      },
      foreign_subsidiary: {
        optionalForeignSubsidiary: optionalForeignSubsidiary(this.show_foreign_subsidiary),
      },
      region: {
        optionalRegionCity: optionalRegionCity(this.country_iso),
      },
      city: {
        optionalRegionCity: optionalRegionCity(this.country_iso),
      },
      email: {
        email,
        required,
      },
      address: {
        required,
      },
    };
  },
  data() {
    return {
      file_size              : 0,
      note_image             : false,
      fileMaxSize            : false,
      placeholder            : 'Загрузить логотип',
      preview                : null,
      errors                 : false,
      company_name           : '',
      country                : '',
      country_iso            : '',
      foreign_subsidiary     : '',
      region                 : '',
      city                   : '',
      phone                  : '',
      email                  : '',
      file_name              : '',
      image                  : '',
      address                : '',
      group                  : '',
      company_type_value     : '',
      llk                    : '',
      about                  : '',
      show_foreign_subsidiary: false,
    };
  },
  computed: {
    countries() {
      return this.company_page.countries;
    },
    foreign_subsidiaries() {
      return this.company_page.foreign_subsidiaries;
    },
    cities_filtered() {
      if (this.chosen_region) {
        return this.company_page.cities.filter((city) => {
          return parseInt(city.region_id) === parseInt(this.chosen_region.id);
        }).map((item) => {
          item.text = item.type;
          return item;
        });
      }
    },
    chosen_region() {
      if (this.region) {
        return this.company_page.regions.filter((x) => x.type == this.region)[0];
      }
    },
    chosen_city() {
      if (this.city) {
        return this.company_page.cities.filter((x) => x.type == this.city)[0];
      }
    },
    regions() {
      return this.company_page.regions.map((i) => {
        i.text = i.type;
        return i;
      });
    },
    ...mapGetters('company_profile', [
      'other_active_region',
      'other_active_city',
      'other_active_group',
    ]),
    ...mapGetters('common', [
      'find_by_option',
    ]),
    ...mapGetters('profile/user', [
      'user',
    ]),
    ...mapGetters('company_profile/info', [
      'company_statuses',
      'company_type',
      'active_group',
      'company_info',
      'company_group',
      'llk_international',
      'company_cities',
      'company_region',
      'company',
    ]),
    ...mapGetters('company_profile/statuses', [
      'user_status',
      'status_confirmed',
      'status_off',
      'status_processing',
      'status_declined',
    ]),
    statuses: {
      get() {
        const s = this.company_statuses.indexOf(this.company_statuses.find((x) => x.active == true));
        return 'radio'+s;
      },
      set($event) {
        const s = this.company_statuses.indexOf(this.company_statuses.find((x) => x.active == true));
        return 'radio'+s;
      },
    },
    phoneMask() {
      let iso = this.country_iso;
      return !iso || iso === 'RU' ? '+7(###)-###-##-##' : '';
    },
    has_file_name: function() {
      return this.file_name || this.placeholder;
    },
  },
  beforeCreate() {
    document.documentElement.style.overflow = 'hidden';
  },
  beforeDestroy() {
    document.documentElement.style.overflow = 'auto';
  },
  mounted() {
    this.email = this.company_page.email;

    this.company_name = this.company_page.name;
    this.about = this.company_page.about;
    this.phone = this.company_page.phone_numbers;
    this.address = this.company_page.address;
    this.file_name = this.company_page.image;

    let country = this.company_page.countries.filter((x) => x.selected)[0];
    country = country ? country : this.company_page.countries[0];

    let foreign_subsidiary = this.company_page.foreign_subsidiaries.filter((x) => x.selected)[0];
    this.foreign_subsidiary = foreign_subsidiary ? foreign_subsidiary : this.company_page.foreign_subsidiaries[0];

    this.country = country.id;
    let country_iso = country.iso;
    this.country_iso = country_iso;

    if (country_iso === 'RU') {
      let region = this.company_page.regions.filter((x) => x.selected)[0];
      this.region = region ? region.type : this.company_page.regions[0].type;
    }

    if (country_iso === 'RU') {
      let city = this.company_page.cities.filter((x) => x.selected)[0];
      this.city = city ? city.type : this.company_page.cities[0].type;
    }

    this.group = this.company_page.groups.filter((x) => x.selected).length ? this.company_page.groups.filter((x) => x.selected)[0].type : '';

    if (this.company_page.types.filter((x) => x.selected).length) {
      this.company_type_value = this.company_page.types.filter((x) => x.selected)[0].type;
    } else {
      this.company_type_value = this.company_page.types[0].type;
    }

    if (this.company_page.llk.filter((x) => x.selected).length) {
      this.llk = this.company_page.llk.filter((x) => x.selected)[0].type;
    }

    if (localStorage.user !== undefined) {
      this.show_foreign_subsidiary = this.user.role_code === 'ADMINISTRATOR';
    }
  },
  methods: {
    async submit() {
      this.$v.$touch();

      if (!this.$v.$invalid) {
        if (this.llk) {
          this.SET_LLL_COMPANY(this.llk);
        }

        this.SET_COMPANY_NAME(this.company_name);
        this.SET_COMPANY_COUNTRY(this.country);
        this.SET_COMPANY_REGION(this.chosen_region ? this.chosen_region.id : null);
        this.SET_COMPANY_CITY(this.chosen_city ? this.chosen_city.id : null);
        this.SET_COMPANY_GROUP(this.group);
        this.SET_COMPANY_TYPE(this.find_by_option(this.company_page.types, this.company_type_value, 'type').id);
        this.SET_COMPANY_ADDRESS(this.address);
        this.SET_COMPANY_PHONE(this.phone);
        this.SET_COMPANY_EMAIL(this.email);
        this.SET_COMPANY_ABOUT(this.about);
        this.SET_COMPANY_LOGO(this.image);
        this.SET_COMPANY_FOREIGN_SUBSIDIARY(this.foreign_subsidiary);
        this.CLOSE_MODAL('company_info');

        await this.submit_company(this.$route.params.id);
        await this.get_other_company(this.$route.params.id);
      }
    },
    ...mapActions('company_profile', [
      'get_other_company',
    ]),
    ...mapMutations('company_profile/modals', [
      'CLOSE_MODAL',
    ]),
    ...mapMutations('users/modals', [
      'CHOOSE_REGION',
    ]),
    ...mapMutations('company_profile/info', [
      'CHANGE_USER_STATUS',
      'SET_COMPANY_NAME',
      'SET_COMPANY_REGION',
      'SET_COMPANY_COUNTRY',
      'SET_COMPANY_FOREIGN_SUBSIDIARY',
      'SET_COMPANY_CITY',
      'SET_COMPANY_GROUP',
      'SET_COMPANY_TYPE',
      'SET_COMPANY_ADDRESS',
      'SET_COMPANY_PHONE',
      'SET_COMPANY_EMAIL',
      'SET_COMPANY_LOGO',
      'SET_COMPANY_ABOUT',
      'SET_SELECTED_GROUP',
      'SET_LLL_COMPANY',
      'SET_TYPE_COMPANY',
    ]),
    send_file($event) {
      let files = $event.target.files;
      let reader = new FileReader();
      reader.readAsDataURL(files[0]);
      reader.onload = () => {
        this.image = reader.result;
      };
    },
    set_file_size($event) {
      this.file_size = $event;
      this.$v.file_size.$touch();
    },
    ...mapActions('company_profile/info', ['submit_company', 'replace_company']),
    hideMulti() {
      this.$refs.multi.blur();
    },
    input_company_name($event) {
      this.company_name = $event.target.value.trim();
      this.$v.email.$touch();
    },
    input_email($event) {
      this.email = $event.target.value.trim();
      this.$v.email.$touch();
    },
    input_address($event) {
      this.address = $event.target.value.trim();
      this.$v.address.$touch();
    },
    click_country(value) {
      this.country = value;
      this.$v.country.$touch();

      let chosen_country = this.countries.find((item) => item.id == value);
      this.country_iso = chosen_country.iso;

      if (chosen_country.iso !== 'RU') {
        this.city = '';
        this.region = '';
      }
    },
    click_city(value) {
      this.city = value;
      this.$v.city.$touch();
    },
    click_region(value) {
      this.region = value;
      this.$v.region.$touch();
    },
    click_group($event) {
      this.group = $event;
      this.$v.group.$touch();
    },
    click_type($event) {
      this.company_type_value = $event;
    },
    click_llk($event) {
      this.llk = $event;
    },
    click_foreign_subsidiary(value) {
      this.$v.country.$touch();
      this.foreign_subsidiary = value;
    },
    sort() {
      return this.items.map( ({name}) => name);
    },
  },
};
</script>
